import {Component} from "../../../gvf/js/component";

let observer = null;

/**
 * Fades an element of the landing modules in the first time it enters the viewport.
 * Every element is its own component; they all share one IntersectionObserver.
 */
export class LandingReveal extends Component{
    ready(){
        super.ready();
        const element = this.$root.get(0);
        if(!("IntersectionObserver" in window)){
            this.$root.addClass("is-visible");
            return;
        }
        this.$root.addClass("is-reveal-armed");
        LandingReveal.getObserver().observe(element);
    }

    /**
     * Returns the observer shared by all the reveal elements
     * @return {IntersectionObserver}
     */
    static getObserver(){
        if(!observer){
            observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if(entry.isIntersecting){
                            entry.target.classList.add("is-visible");
                            observer.unobserve(entry.target);
                        }
                    });
                },
                {rootMargin: "0px 0px -8% 0px", threshold: 0.1}
            );
        }
        return observer;
    }
}
